import React from "react";
import { TextField } from "@mui/material";
import { useField } from "formik";

interface IFormikPreviewFormNumberProps {
  name: string;
  placeholder: string;
  labelledById?: string;
  label: string;
}
export const FormikPreviewFormNumber: React.FC<
  IFormikPreviewFormNumberProps
> = ({ name, labelledById, label, placeholder }) => {
  const [field, meta, helpers] = useField<string>({
    name,
  });
  const value = field.value ? parseInt(field.value) : "";
  return (
    <TextField
      type="number"
      value={value}
      aria-labelledby={labelledById}
      onChange={(event) => helpers.setValue(event.target.value)}
      label={label}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      error={meta.touched && meta.error ? true : false}
      helperText={meta.error}
      fullWidth
      sx={{
        backgroundColor: (theme) => ` ${theme.palette.common.white}`,
      }}
    />
  );
};
